// Groups verification recovery workflows behind a recovery-focused auth application boundary.
import type {
  GetVerificationRecoveryStatusInput,
  RequestVerificationEmailInput,
  VerificationRecoveryPort,
} from '../core/types';

export function createVerificationRecoveryService(port: VerificationRecoveryPort) {
  return {
    getVerificationRecoveryStatus(input: GetVerificationRecoveryStatusInput) {
      return port.getVerificationRecoveryStatus(input);
    },
    requestVerificationEmail(input: RequestVerificationEmailInput) {
      return port.requestVerificationEmail(input);
    },
  };
}
